<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3 class="text-left">Manage Product Category <b-breadcrumb :items="breadcrumb"></b-breadcrumb></h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()" v-if="$root.chkperm('productcategory','add')">Add Category</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" v-if="row.item.user_id == $session.get('user_info').user_id" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" v-if="row.item.user_id == $session.get('user_info').user_id" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing 1 to 5 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-modal" :title="(selectedItem.id > 0)?'Edit Product Category':'Add Product Category'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-1">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Title</label></b-col>
									<b-col><b-form-input v-model="selectedItem.title" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Parent Category</label></b-col>
									<b-col cols="5"><b-form-select v-model="selectedItem.parent" :options="filtercategory" size="sm" required></b-form-select></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">URL Slug</label></b-col>
									<b-col cols="10"><b-form-input v-model="selectedItem.url_slug" size="sm" required></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Category Description</label></b-col>
									<b-col cols="10">
										<ckeditor :editor="editor" v-model="selectedItem.description" :config="editorConfig"></ckeditor>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Position</label></b-col>
									<b-col cols="4"><b-form-input v-model="selectedItem.position" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Status</label></b-col>
									<b-col cols="4"><b-form-select v-model="selectedItem.status" :options="$root.status_options" size="sm" required></b-form-select></b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row class="mb-3">
							<b-col><div class="alert alert-warning heading mb-0" role="alert" size="sm">SEO Information</div>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Meta Keywords</label></b-col>
									<b-col><b-form-input v-model="selectedItem.meta_keyword" size="sm" placeholder="Keywords"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="2" class="text-right"><label class="font-sm">Meta Description</label></b-col>
									<b-col><b-form-textarea v-model="selectedItem.meta_description" size="sm" rows="3" max-rows="6" placeholder="Description"></b-form-textarea></b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		//var self = this;
		return{
			loading: true, 
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Artwork Colors',
					active: true
				}
			],
			recordUrl: this.$root.WEBAPI+'productcategory-record',
			insertUrl: this.$root.WEBAPI+'productcategory-insert',
			updateUrl: this.$root.WEBAPI+'productcategory-update',
			deleteUrl: this.$root.WEBAPI+'productcategory-delete',
			filtercategory: [{ text: 'Root', value: '0' }],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			editor: ClassicEditor,
			editorConfig: {
				toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', 'bulletedList', 'numberedList', 'blockQuote' ]
			},
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'parent', label: 'Parent'},
				{ key: 'url_slug', label: 'Url Slug'},
                { key: 'position', label: 'Position'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
				title: '',
				parent: '',
				position: 0,
				status: 0
			}
		};
	},
	methods: {
		redirectUrl(url){
			this.$router.push(url);
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			
			this.filtercategory = [{ text: 'Root Category', value: '0' }];
			this.records.forEach(function(item){
				if(item.parent == 0){
					self.filtercategory.push({ text: item.title, value: item.id });
					self.filterChildCategory(item.id, '--');
				}
			});
			this.$root.$emit('bv::show::modal', 'my-modal');
		},
		showUpdateModal(item, index, button) {
			var self = this;
			this.selectedItem = Object.assign({}, item);

			this.filtercategory = [{ text: 'Root Category', value: '0' }];
			this.records.forEach(function(item){
				if(item.parent == 0){
					self.filtercategory.push({ text: item.title, value: item.id });
					self.filterChildCategory(item.id, '--');
				}
			});
			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		filterChildCategory(category_id, space){
			var self = this;
			this.records.forEach(function(item){
				if(item.parent == category_id){
					self.filtercategory.push({ text: space+item.title, value: item.id });
					self.filterChildCategory(item.id, '--')
				}
			});
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Color.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
